import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import withThemeProps from '../withThemeProps';
var progressAnimation = keyframes(["\n  0% {\n    width: 0;\n  }\n  100% {\n    width: 100%;\n  }\n"]);
var Wrapper = styled.span.withConfig({
  displayName: "ProgressLoadingIndicator__Wrapper",
  componentId: "sc-pbu96x-0"
})(["\n  display: block;\n  ", ";\n"], props => props.containerStyle);
var ProgressBar = styled.span.withConfig({
  displayName: "ProgressLoadingIndicator__ProgressBar",
  componentId: "sc-pbu96x-1"
})(["\n  display: block;\n  ", ";\n  background: ", ";\n  animation-name: ", ";\n  animation-duration: ", "ms;\n  animation-timing-function: ", ";\n  animation-iteration-count: infinite;\n  ", ";\n"], props => ({
  height: props.thickness
}), props => props.color || 'currentColor', props => props.animation, props => props.animationDuration, props => props.animationTimingFunction, props => props.fillStyle);
/**
 * A loading indicator with a progress bar animation. The progress bar animation
 * will repeat as long as necessary, since it is typically used for showing
 * something with indeterminate progress.
 */

export function ProgressLoadingIndicator(_ref) {
  var animation = _ref.animation,
      animationDuration = _ref.animationDuration,
      animationTimingFunction = _ref.animationTimingFunction,
      children = _ref.children,
      color = _ref.color,
      fillStyle = _ref.fillStyle,
      thickness = _ref.thickness,
      rest = _objectWithoutProperties(_ref, ["animation", "animationDuration", "animationTimingFunction", "children", "color", "fillStyle", "thickness"]);

  return /*#__PURE__*/React.createElement(Wrapper, rest, /*#__PURE__*/React.createElement(ProgressBar, {
    animation: animation,
    animationDuration: animationDuration,
    animationTimingFunction: animationTimingFunction,
    color: color,
    "data-progress-bar": "",
    fillStyle: fillStyle,
    thickness: thickness
  }), children);
}
ProgressLoadingIndicator.propTypes = {
  /**
   * A CSS animation name or `keyframes` object created with
   * `styled-components`.
   */
  animation: PropTypes.any,

  /**
   * The duration of the progress animation in milliseconds.
   */
  animationDuration: PropTypes.number,

  /**
   * The easing function.
   */
  animationTimingFunction: PropTypes.string,

  /**
   * Content to render inside the container and after the progress bar element.
   * You can use this to include a message.
   */
  children: PropTypes.node,

  /**
   * The fill color of the progress bar. By default it will inherit the current
   * foreground color.
   */
  color: PropTypes.string,

  /**
   * Styles to apply to the outer container element that the progress bar will
   * grow to fill. Can be anything `styled-components` supports in `styled`
   * interpolations.
   */
  containerStyle: PropTypes.any,

  /**
   * Styles to apply to the inner progress bar element that will grow to fill
   * its container. Can be anything `styled-components` supports in `styled`
   * interpolations.
   */
  fillStyle: PropTypes.any,

  /**
   * The height of the inner progress bar element.
   */
  thickness: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
ProgressLoadingIndicator.defaultProps = {
  'aria-label': 'Loading…',
  animation: progressAnimation,
  animationDuration: 3000,
  animationTimingFunction: 'ease-out',
  color: 'currentColor',
  thickness: 4
};
export default withThemeProps(ProgressLoadingIndicator, {
  section: 'progressLoadingIndicator',
  defaultVariant: 'default'
});